const EXCLUDED_PROPERTIES = [
  'toJSON',
  ...Object.getOwnPropertyNames(Object.getPrototypeOf({})),
]

const flattenObject = (object: object) => {
  const flat: Record<string, any> = {}
  let proto = object
  while (proto) {
    for (const i of Object.getOwnPropertyNames(proto)) {
      let value
      try {
        value = (object as any)[i]
      } catch {
        // in case a getter throws
        continue
      }

      if (!EXCLUDED_PROPERTIES.includes(i) && typeof value !== 'function') {
        flat[i] = value
      }
    }

    proto = Object.getPrototypeOf(proto)
  }
  return flat
}

const recursiveFlatten = (
  value: unknown,
  visitedObjects: Set<unknown> = new Set(),
): any => {
  if (typeof value !== 'object' || value === null) {
    return value
  }

  if (visitedObjects.has(value)) {
    return '[visited]'
  }
  visitedObjects.add(value)

  const object = flattenObject(value)
  Object.keys(object).forEach(key => {
    object[key] = recursiveFlatten(object[key], visitedObjects)
  })
  return object
}

export const gatherErrorCauseChain = (error: any) => {
  const errors = []
  let e = error
  const visitedCauses = new Set()
  while (true) {
    visitedCauses.add(e)

    const object = recursiveFlatten(e)
    if (typeof object === 'object' && object !== null) {
      delete object.cause
    }
    errors.push(object)

    const hasCause = typeof e === 'object' && e !== null && 'cause' in e
    if (hasCause && !visitedCauses.has(e.cause)) {
      e = e.cause
    } else {
      break
    }
  }
  return errors
}
